import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	newAutomationRule: {
		id: 'servicedesk.automation.summary.add-rule.new-automation-rule',
		defaultMessage: 'New automation rule',
		description: '',
	},
});
